import { ref, watch } from 'vue';
import { useStore } from 'vuex'
import { allLanguages } from '@/data/globals'

export default function useLang () {
    const store = useStore()
    const lang = ref(store.state.language)


    function checkUserLanguage() {
        // console.log('localStorage getItem')
        let localItem = localStorage.getItem('language')
        // Для информации:
        // encodeURI заменяет киррилические и другие символы на соответствующими им UTF-8 escape-последовательности. Незаменяемые символы: латинский алфавит, десятичные цифры, - _ . ! ~ * ' ( ) #
        if(localItem) localItem = encodeURI(localItem)
        if(!allLanguages.includes(localItem)) localItem = 'uk'

        store.commit('SetLanguage', localItem)
        // console.log('   store.state.language: ', store.state.language);
    } // checkUserLanguage


    watch(() => store.state.language, function() {
        lang.value = store.state.language
    })

    
    return { checkUserLanguage, lang }
}